import styled from 'styled-components';
import { theme, toRem } from '../../styles';
import { colors } from '../../styles/colors';

export const StyledModalSection = styled.div`
  .prearrival-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    backdrop-filter: blur(5px);
  }
  .button-wrapper {
    text-align: right;
  }

  .modal-heading {
    font: normal normal 700 ${toRem(20)} / ${toRem(20)} var(--t-base-font-family);
    &.mb-4 {
      @media ${theme.mediaQuery.allMobiles} {
        margin-bottom: 15px !important;
      }
    }
  }
  .exit-modal {
    background-color: ${colors.white};
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
    max-width: 596px;
    padding: 80px 40px 40px !important;
    position: relative;
    z-index: 10000; /* Ensure the modal is on top of the overlay */
    margin: 0 auto;
    @media ${theme.mediaQuery.allMobiles} {
      max-width: 330px;
      border-radius: 8px;
      padding: 28px !important;
    }

    .button-wrapper {
      @media ${theme.mediaQuery.allMobiles} {
        display: block !important;
      }
      button {
        font: normal normal 700 ${toRem(14)} / ${toRem(17)} var(--t-base-font-family) !important;
        padding: 11px 12px 12px !important;
        width: 120px !important;
        @media ${theme.mediaQuery.allMobiles} {
          font: normal normal 700 ${toRem(13)} / ${toRem(16)} var(--t-base-font-family) !important;
          width: 100% !important;
          height: auto;
          padding: 8px 12px !important;
          width: 276px !important;
        }
      }
    }
    &.submited-modal {
      @media ${theme.mediaQuery.allMobiles} {
        padding: 28px 18px !important;
      }
    }
  }

  .close-button-container {
    position: absolute;
    top: -42px;
    right: 3px;
    @media ${theme.mediaQuery.allMobiles} {
      top: -10px;
      right: -14px;
    }
  }

  .close-button {
    border: none;
    width: 32px;
    height: 32px;
    font-size: 16px;
    color: ${colors.black} !important;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.25rem;
    background-color: ${colors.neutral20} !important;
  }

  .subtitle {
    text-align: left;
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 36px !important;
    @media ${theme.mediaQuery.allMobiles} {
      margin-bottom: 15px !important;
    }
  }

  button {
    &.close-button {
      width: 32px;
      border-radius: 0px;
    }
  }

  .inside-div2 {
    padding: 0px 94px;
    @media ${theme.mediaQuery.allMobiles} {
      padding: 0px;
    }
    p {
      font-size: 12px;
      line-height: 16px;
      font-weight: 700;
    }
  }

  .modal-select {
    border: 1px solid ${colors.grey2};
    max-width: 266px;
    height: 32px;
    padding: 5px;
  }
  .custom-btn {
    max-width: 120px !important;
    width: 100% !important;
    @media ${theme.mediaQuery.allMobiles} {
      max-width: none !important;
    }
  }
`;
